<template>
    <section class="py-16">
        <div class="container mx-auto">
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-5">
                    <p class="text-lg mb-8  text-dim_dark">
                        <span class="text-dim_gold_txt"> NEVADO PREMIER</span> — наша компания <br>
                        является лидером на рынке натяжных <br>
                        потолков, имея за плечами более чем <br>
                        14 лет опыта работы в этой сфере
                    </p>
                </div>
                <div class="col-span-7">
                    <p class="text-lg mb-8  text-dim_dark">
                        <br>
                        Мы предоставляем услуги под ключ, включая <br>
                        консультации, замеры, установку и даже  <br>
                        помощь в выборе материалов.
                    </p>
                </div>
                <div class="col-span-5">
                    <div class="w-full h-full bg-center bg-cover bg-no-repeat bg-[url('https://premier.nevado.ru/dist/hero-slider-5.png?57b7f91c46bc47d231a44e4ba8a9eadc')]"></div>
                </div>
                <div class="col-span-7">
                    <div class="grid grid-cols-12 gap-8">
                        <div class="col-span-7">
                            <div class="p-5 py-8 rounded border border-solid border-dim_gold_2 hover:bg-dim_gold_2 transition-all">
                                <h3 class="text-dim_dark text-xl font-bold mb-2">Авторские потолки</h3>
                                <p class="text-lg text-dim_dark">
                                    Мы предлагаем качественные услуги и уникальный дизайн, который подчеркнет индивидуальность вашего помещения
                                </p>
                            </div>
                        </div>
                        <div class="col-span-5">
                            <div class="p-5 py-8 rounded border border-solid border-dim_gold_2 hover:bg-dim_gold_2 transition-all">
                                <h3 class="text-dim_dark text-xl font-bold mb-2">Современные системы</h3>
                                <p class="text-lg text-dim_dark">
                                    Используем последние современные системы: KRAAB, FLEXY и ШТОК
                                </p>
                            </div>
                        </div>
                        <div class="col-span-5">
                            <div class="p-5 py-8 rounded border border-solid border-dim_gold_2 hover:bg-dim_gold_2 transition-all">
                                <h3 class="text-dim_dark text-xl font-bold mb-2">Современные системы</h3>
                                <p class="text-lg text-dim_dark">
                                    Используем последние современные системы: KRAAB, FLEXY и ШТОК
                                </p>
                            </div>
                        </div>
                        <div class="col-span-7">
                            <div class="w-full h-full bg-center bg-cover bg-no-repeat bg-[url('https://premier.nevado.ru/dist/hero-slider-5.png?57b7f91c46bc47d231a44e4ba8a9eadc')]"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>